import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { PortfolioInput } from "@graphql/api";

import { BASE_PORTFOLIOS_PATH } from "@routing/Portfolios";

import { Toast } from "@covertree/utils";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export function PortfolioConfigurationSuccess() {
  const state = useLocation().state as PortfolioInput | undefined;

  useEffect(() => {
    if (!state) {
      Toast.showError("No portfolio data found, please try again later.");
    }
  }, [state]);

  if (!state) {
    return <Navigate to={`/${BASE_PORTFOLIOS_PATH}`} replace />;
  }

  return (
    <Stack>
      <Typography variant="h5" gutterBottom>
        Portfolio {state.name} has been successfully created!
      </Typography>
      <Typography variant="body1">
        Synchronization of data is now in progress. It can take several minutes
        depending on the size of your portfolio. You will be notified once the
        synchronization is complete by Slack notification on the Maple Slack
        channel.
      </Typography>
    </Stack>
  );
}
